import classes from "./article.module.css";

import { Container } from "../container";

interface ArticleProps {
  article: any;
}

const AuthorBio = (authors) => {
  const primaryAuthor =
    authors.author && authors.author.length ? authors.author[0] : false;
  if (!primaryAuthor) return;

  return (
    <div className={classes.marketing__article_authorbio}>
      <div></div>
      <div>
        <strong>{primaryAuthor.name}</strong>
        <p>{primaryAuthor.bio}</p>
      </div>
    </div>
  );
};

const Article = ({ article }: ArticleProps) => (
  <Container isNarrow>
    <div
      className={classes.marketing__article}
      dangerouslySetInnerHTML={{ __html: article.html }}
    ></div>
    {/* <AuthorBio author={article.authors} /> */}
  </Container>
);

export { Article };
